import React from 'react';
import AppBaseComponent from '../../../../components/AppBaseComponent';
import {connect} from "react-redux";
import tapIcon from "../../../../services/TapIcon";
import { Modal } from 'bootstrap';
import TapIcon from '../../../../services/TapIcon';
import TapSelect from "../../../../components/ui/TapSelect";
import { ORG_API_BASE_URL_2 } from '../../../../services/TapApiUrls';
import HttpAPICall from '../../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import Loader from '../../../../components/ui/Loader/Loader';


class Setting extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initGeneralConfigForm               =        {
            ticket_expense                                :   'N',
            ticket_allocation                             :   'N',
            ticket_consumption                            :   'N',
            ticket_allow_tag                              :   'N', 
            ticket_allow_employees                        :   'N', 
            enable_ticket_mttr                            :   'N',
            ticket_demand                                 :   'N',
            activate_root_cause_analysis_for_tickets      :   'N'
        };

        this.state                      =       {
            saveFormSubmitting                  :       false,
            allAdditonalAttributes              :       [],
            generalConfigloading                :       false,
            general_config_list                 :        null,
            generalConfigForm                   :       {...this.initGeneralConfigForm},
            editFormSubmiting                   :        false,
            currentTaskKey                      :       ''
        };

        
        this.configData = [
            {  key: "ticket_expense" ,                          value :"Enable Expense" },
            {  key: "ticket_allocation",                        value :"Enable Allocation"},
            {  key: "ticket_consumption",                       value :"Enable Consumption" },
            {  key: "ticket_demand",                            value :"Enable Item Demand" },
            {  key: "ticket_allow_tag",                         value :"Enable Tags" },
            {  key: "ticket_allow_employees",                   value :"Enable Employees" },
            {  key: "enable_ticket_mttr",                       value :"Enable MTTR" },
            {  key: "activate_root_cause_analysis_for_tickets", value :"Activate Root Cause Analysis (RCA)" },
            {  key: "ticket_warehouse_indent",                  value :"Enable Warehouse Indent" },
            {  key: "ticket_purchase_requisition",              value :"Enable Purchase Requisition" },
            {  key: "ticket_purchase_order",                    value :"Enable Purchase Order" },
            {  key: "allow_multiple_ticket_create_to_ticket_for", value : "Allow Multiple Ticket with same Ticket For(Asset, Sub Assembly...)"}
        ]

        this.settingEditUrl             =   ORG_API_BASE_URL_2  + '/setting_edit';
        this.settingUrl                 =   ORG_API_BASE_URL_2  + '/settings';
    }
    
    componentDidMount() {
        this.getGeneralSettingListing();
        this.editGeneralConfiguration        =        new Modal(document.getElementById('editGeneralConfigurationModal'), {keyboard: false, backdrop :false});
    }

    getGeneralSettingListing = () => {        

        let params = {
            keys : this.configData.map(d => d.key),
        }

        // [ 'ticket_expense','ticket_allocation','ticket_consumption', 'ticket_allow_tag','ticket_demand', 'ticket_allow_employees', 'enable_ticket_mttr','activate_root_cause_analysis_for_tickets'],

        this.setState({ generalConfigloading: true });
        HttpAPICall.withAthorization('GET', this.settingUrl, this.props.access_token, {...params}, {}, (resp) => {
            this.setState({ general_config_list: resp.data.data })
        }).then(() => this.setState({ generalConfigloading: false }));
    }

    editGeneralConfigurationInit = (key = '') => {
        this.editGeneralConfiguration.show();
        if(this.state.general_config_list) {
            let generalConfigForm = [];
            if (this.state.general_config_list) {
                Object.entries(this.state.general_config_list).forEach(([key, value]) => {
                  let name = key;
                  let val = value;
                  generalConfigForm[name] = val;
                });
              }
              
            this.setState({generalConfigForm : generalConfigForm,currentTaskKey : key})
        }
    }

    submitGeneralConfigurationForm        =    (e)          =>     {
        e.preventDefault();
        this.setState({editFormSubmiting : true});
        HttpAPICall.withAthorization('PUT', this.settingEditUrl, this.props.access_token, {} , {...this.state.generalConfigForm} , (response) => {
            toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
            this.editGeneralConfiguration.hide();
            this.getGeneralSettingListing();
        }).then(() => this.setState({editFormSubmiting: false}));
    }

    editMTTRConfigurationInit   =   (key = '') => {
        this.editGeneralConfiguration.show();
        if(this.state.general_config_list) {
            let generalConfigForm = [];
            if (this.state.general_config_list) {
                Object.entries(this.state.general_config_list).forEach(([key, value]) => {
                  let name = key;
                  let val = value;
                  generalConfigForm[name] = val;
                });
              }
              
            this.setState({generalConfigForm : generalConfigForm,currentTaskKey : key}, () => {
            })
        }
    }


    editGeneralConfigurationModalJsx      =    ()           =>     {
        return (
            <div className="modal fade" id="editGeneralConfigurationModal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">Edit General Configuration</h5>
                        </div>
                        <form onSubmit={this.submitGeneralConfigurationForm}>
                            <div className="modal-body p-3">
                            <div className="row align-items-center mb-2 mt-2 px-2">
                                    <div className="col-md-8">
                                        <label className="form-label">{this.state.currentTaskKey && this.configData.find(conf => conf.key === this.state.currentTaskKey).value}</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label>
                                            <input
                                            className='me-2'
                                                type="radio"
                                                name={this.state.currentTaskKey}
                                                value="Y"
                                                onChange={(e) => this.formInputHandler(e, "generalConfigForm")}
                                                checked={this.state.generalConfigForm[this.state.currentTaskKey] === "Y"}
                                            />
                                             Yes
                                        </label>
                                    </div>
                                    <div className="col-md-2">
                                        <label>
                                            <input
                                            className='me-2'
                                                type="radio"
                                                name={this.state.currentTaskKey}
                                                value="N"
                                                onChange={(e) => this.formInputHandler(e, "generalConfigForm")}
                                                checked={this.state.generalConfigForm[this.state.currentTaskKey] === "N"} /> No
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" disabled={this.state.editFormSubmiting} data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary" disabled={this.state.editFormSubmiting} >Save {this.state.editFormSubmiting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : null}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
  }

    generalConfigurationJsx               =    ()           =>     {
        let data = this.state.general_config_list;
        return (<table className="table table-hover table-bordered table-sm mt-2">
            <thead className="table-secondary">
                <tr className="text-center">
                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                    <th scope="col" className="text-start">Configuration</th>
                    <th scope="col" style={{ width: "25%" }}>Value</th>
                    <th scope="col" style={{ width: "10%" }}>Action</th>
                </tr>
            </thead>
            <tbody>
                {this.configData.map((config , i)=> (
                     data && Object.keys(data).includes(config.key) &&
                    <>
                    <tr className="text-center" key={config.key}>
                    <td>{i+1}</td>
                    <td className="text-start">{config.value}</td>
                    <td>{data[config.key] == 'Y' ? "Yes" : "No"}</td>
                    <td> 
                        <span className="dropdown">
                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a className="dropdown-item" role="button" onClick={() => this.editGeneralConfigurationInit(config.key)}>Edit</a></li>
                            </ul>
                        </span>
                    </td>
                </tr>
                    </>
                ))}
            </tbody>
        </table>)
    }

    render() {
      
        return (<div>

            <div className="p-1">
                <div className="tab_content_wrapper mt-2"><span className="content_heading">General Setting</span>
                </div>
                {this.state.generalConfigloading ? <Loader />
                    : this.generalConfigurationJsx()}
                {this.editGeneralConfigurationModalJsx()}
            </div>


            {this.editGeneralConfigurationModalJsx()}

        </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        access_token            :        state.auth.access_token
    };
};

export default connect(mapStateToProps)(Setting);